/* tslint:disable max-classes-per-file */

import { validationMessages } from './messages';

export type ValidationErrorType = 'filled' | 'email';

export class BaseValidationError extends Error {
  constructor(message: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export class ValidationError extends BaseValidationError {
  public type: ValidationErrorType;

  constructor(type: ValidationErrorType) {
    super(`ValidationError: ${type}`);

    this.message = validationMessages[type];
    this.name = 'ValidationError';
    this.type = type;
  }
}



// WEBPACK FOOTER //
// ./src/shared/errors/index.ts